import { Row, Col, Divider,Spin } from "antd";


import SubHeader from "../components/SubHeader";

import "antd/dist/antd.css";
import '../App.css';
import React from "react";
//RUN: new header component 16/04/2021
import HeaderComponent from "../components/HeaderComponent";
import LoginScreen from "./LoginScreen";
import { Redirect } from "react-router";


export default class WorkFormScreen extends React.Component {
  
  constructor(props) {
 
    super(props);
    this.state = {
      items: [],
      username: "",
      password: "",
      //RUN: เพิ่ม การ get Language 16/04/2021
      language: localStorage.getItem("Language"),
      selfEvalState: 0,
      spinner: true
    };

  }

  componentDidMount() {
    console.log('asicnaiosicmsom')
    this.spinnerControl()
    fetch(process.env.REACT_APP_API_URL + "/api/getEvalStatus", {
      method: "post",

      headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
      },

      body: JSON.stringify({
          empid: localStorage.getItem("EmpId"),
      }),
  })
      .then((Response) => Response.json())
      .then((result) => {
   
    console.log('ssssssssssssssssssss',result[0].selfEvalStatus)
    
      localStorage.setItem("selfEvalStatus", result[0].selfEvalStatus);
      localStorage.setItem("workLifeEvalStatus", result[0].workLifeEvalStatus);
      localStorage.setItem("leadershipEvalStatus", result[0].leadershipEvalStatus);
      localStorage.setItem("selfEvalStatusBackState",result[0].selfEvalStatusBackState)
      this.setState({selfEvalState : localStorage.getItem("selfEvalStatus"),
     })

      })
      this.spinnerControl()


  }
  
  componentWillReceiveProps(nextProps){
    console.log('nextProps',nextProps)
    this.setState({language: nextProps.lang})
    localStorage.setItem("Language", nextProps.lang);
  }

  renderCalendar() {
    return (

      <table id="calendar">
        {this.state.language == 'TH' ?
          <tr>
            <th> <b> ระยะเวลา </b> </th>
            <th> <b> การดำเนินการ </b> </th>
          </tr>
          :
          <tr>
            <th> <b> Duration </b> </th>
            <th> <b> Action </b> </th>
          </tr>

        }
        {this.state.language == 'TH' ?
          <tr>
            <td> 4 – 24 เมษายน 2565 </td>
            <td> สำนักทรัพยากรบุคคล เปิดระบบการประเมินผลการปฏิบัติงานของบุคลากรมหาวิทยาลัยพายัพ ประจำปีการศึกษา 2564 ให้บุคลากรทุกคนเข้าทำการประเมินตนเอง ผ่านระบบการประเมินที่กำหนด
            </td>
          </tr>
          :
          <tr>
            <td> 4 - 24 April, 2022 </td>
            <td> Human Resources Office will post the on-line personal evaluation form for personnel to use at http://hrms.payap.ac.th
          </td>
          </tr>
        }
        {this.state.language == 'TH' ?
          <tr>
            <td> 25 เมษายน – 1 พฤษภาคม 2565 </td>
            <td> ผู้บังคับบัญชาระดับต้นประเมินผลการปฏิบัติงานของบุคลากร
            </td>
          </tr>
          :
          <tr>
            <td> 25 April – 1 May 2022 </td>
            <td> The initial supervisor assess a result of work performance (scoring) of faculties or staffs.
          </td>
          </tr>
        }
        {this.state.language == 'TH' ?
          <tr>
            <td> 2 – 11 พฤษภาคม 2565 </td>
            <td>
              <li> <b> กรณีคณะวิชา </b> ให้ผู้บริหารระดับคณบดีเป็นผู้พิจารณาให้ระดับผลการปฏิบัติงาน ตามคำแนะนำของคณะกรรมการบริหารคณะวิชาหรือวิทยาลัย </li>
              <li> <b> กรณีหน่วยงานสนับสนุน </b> ให้ผู้บริหารระดับผู้อำนวยการหรือหัวหน้างานเป็นผู้พิจารณาให้ระดับปฏิบัติงาน </li>
            </td>
          </tr>
          :
          <tr>
            <td> 2 – 11 May 2022 </td>
            <td>
              <li> <b> In case of Faculties and Colleges, </b> the Dean assess a result of work performance of faculties or staffs by advices of Faculty or College Board. </li>
              <li> <b> In case of non – academic Department, </b> The Director or Head of office assess a result of work performance. </li>
            </td>
          </tr>
        }
        {this.state.language == 'TH' ?
          <tr>
            <td> 12 – 22 พฤษภาคม 2565 </td>
            <td> รองอธิการบดีหรือผู้ช่วยอธิการบดี รวบรวมและสรุปข้อมูลผลการประเมินและระดับการประเมิน ผลการปฏิบัติงานของบุคลากร </td>
          </tr>
          :
          <tr>
            <td> 12 – 22 May 2022 </td>
            <td> Vice president or Assistant to the president evaluate the job performance of personnel. </td>
          </tr>
        }
        {this.state.language == 'TH' ?

          <tr>
            <td> 24 พฤษภาคม 2565 </td>
            <td> คณะกรรมการบริหารมหาวิทยาลัยพายัพพิจารณากลั่นกรองผลการประเมินการปฏิบัติงานของบุคลากร </td>
          </tr>
          :
          <tr>
            <td> 24 May 2022 </td>
            <td> Payap University administrative executive committee considers the overview of personnel performance. </td>
          </tr>
        }
        {this.state.language == 'TH' ?

          <tr>
            <td> 27 พฤษภาคม 2565 </td>
            <td> รักษาการอธิการบดีพิจารณาอนุมัติ  </td>
          </tr>
          :

          <tr>
            <td> 27 May 2022 </td>
            <td> Interim President considers approving the reports.</td>
          </tr>
        }

      </table>

    )


  }

  //RUN: เพิ่ม changeLangFunction เพื่อทำการ setstate ให้ language 16/04/2021
  changeLangFunction(item) {
    localStorage.setItem("Language", item);
    this.setState({ language: item })
  }

  spinnerControl() {
    this.setState({ spinner: !this.state.spinner })
  }

  render() {
    const { items } = this.state;
    console.log('items', items);



    console.log('render workform')
    return (
      <div>
                 <Spin tip="Loading..." spinning={this.state.spinner}>
        {/* // RUNเพิ่มการ ส่ง props ให้ทำการ callback function และ re-render 
component เมื่อทำการเปลี่ยนภาษา 16/04/2021 */}

        <SubHeader />
        <div style={{ marginBlock: 15 }}>
          <Row>
            {/* Start Left Section */}
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <div style={{ padding: 15 }}>
                <Divider Divider orientation="left">
                  {this.state.language == 'TH' ?

                    <h2> ประกาศ </h2>
                    :
                    <h2> Announcement </h2>

                  }
                </Divider>
                {this.state.language == 'TH' ?

                  <p>
                    ประกาศมหาวิทยาลัยพายัพ เรื่อง การประเมินผลการปฏิบัติงานของบุคลากรมหาวิทยาลัยพายัพ ประจำปีการศึกษา 2564 (ประกาศ ณ วันที่ 21 มีนาคม 2565)
                  </p>
                  :
                  <p>
                   Payap University Announcement - The assessment of Payap University's personnel Job Performance (announced on March 4, 2025).
                  </p>
                }
                
                {this.renderCalendar()}
              </div>

            </Col>
            {/* End Left Section */}

            {/* Start Right Section */}
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <div style={{ padding: 15 }}>
                <Divider Divider orientation="left">
                  {this.state.language == 'TH' ?
                    <h2> ข้อมูลตนเอง </h2>
                    :
                    <h2> Profile </h2>
                  }
                </Divider>

                {/* render name */}
                {this.state.language == 'TH' ?

                  <p style={{ fontSize: 18 }}>
                    {localStorage.getItem("TitleTH") +
                      " " +
                      localStorage.getItem("FirstNameTH") +
                      " " +
                      localStorage.getItem("LastNameTH")
                    }
                  </p>
                  :
                  <p style={{ fontSize: 18 }}>
                    {localStorage.getItem("TitleEN") +
                      " " +
                      localStorage.getItem("FirstNameEN") +
                      " " +
                      localStorage.getItem("LastNameEN")}
                  </p>
                }

                {/* render id */}
                {this.state.language == 'TH' ?
                  <p> รหัสบุคลากร: { localStorage.getItem("EmpId")} </p>
                  :
                  <p> Personnel Code: { localStorage.getItem("EmpId")} </p>

                }

                {/* render status */}
                {this.state.language == 'TH' ?
                  <p style={{ fontSize: 16, fontWeight: "bold" }}> สถานะ </p>
                  :
                  <p style={{ fontSize: 16, fontWeight: "bold" }}> Status </p>

                }

                {this.state.selfEvalState == 1 ? (
                  this.state.language == 'TH' ? <p>ยังไม่ได้ประเมินตนเอง</p> : <p>No Record</p>
                ) : this.state.selfEvalState == 2 ? (
                  this.state.language == 'TH' ? <p>กำลังประเมิน</p> : <p>In Progress</p>
                ) : this.state.selfEvalState == 3 ? (
                  this.state.language == 'TH' ? <p>ประเมินสำเร็จ</p> : <p>Completed</p>
                ) : null}

                {/* render position */}
                {this.state.language == 'TH' ?

                  <p style={{ fontSize: 16, fontWeight: "bold" }}> ตำแหน่ง </p>
                  :
                  <p style={{ fontSize: 16, fontWeight: "bold" }}> Position </p>

                }
                {this.state.language == 'TH' ?

                  <p> {localStorage.getItem("PositionNameTH") } </p>
                  :
                  <p> {localStorage.getItem("PositionNameEN")} </p>

                }


                {/* render department */}
                {this.state.language == 'TH' ?
                  <p style={{ fontSize: 16, fontWeight: "bold" }}> สังกัด </p>
                  :
                  <p style={{ fontSize: 16, fontWeight: "bold" }}> Department </p>

                }
                {this.state.language == 'TH' ?

                  <p> {localStorage.getItem("DepartmentTH")} </p>
                  :
                  <p> {localStorage.getItem("DepartmentEN")} </p>

                }
              </div>

              <div style={{ padding: 15 }}>
                <Divider Divider orientation="left">
                  {this.state.language == 'TH' ?

                    <h2> ดาวน์โหลด </h2>
                    :
                    <h2> Download </h2>

                  }
                </Divider>
                <ul>
                  <li>
                    {this.state.language == 'TH' ?
                      <a href="/files/THAI_Academic.pdf" download>
                        ตารางแสดงรายละเอียดและคำอธิบายของเกณฑ์และตัวชี้วัดการประเมินในแต่ละระดับของสายวิชาการ
                      </a>
                      :
                      <a href="/files/ENG_Academic.pdf">
                       Specifications of criteria and indicators for academic / instructors
                      </a>
                    }
                  </li>
                  <li>
                    {this.state.language == 'TH' ?
                      <a href="/files/THAI_Non_academic.pdf" download>
                       ตารางแสดงรายละเอียดและคำอธิบายของเกณฑ์และตัวชี้วัดการประเมินในแต่ละระดับของบุคลากรสายสนับสนุน 
                      </a>
                      :
                      <a href="/files/ENG_Non_academic.pdf" download>
                        Specifications of criteria and indicators for non – academic                      
                      </a>
                    }
                  </li>
                  <li>
                    {this.state.language == 'TH' ?

                      <a href="/files/THAI_Competency.pdf" download>
                        คำอธิบายระดับผลการปฎิบัติงานและระดับความสามารถเชิงสมรรถนะ
                      </a>
                      :
                      <a href="/files/ENG_Competency.pdf" download>
                        Explanation of Job Performance and Competency Levels
                      </a>
                    }
                  </li>
                 
                </ul>
              </div>
            </Col>
            {/* End Right Section */}
          </Row>
        </div>
        </Spin>
      </div>
    );
  }

  
}
